import { createAction, props } from '@ngrx/store';

import { GiftCardTransaction } from '../models/gift-card.model';
import {
    GiftCardActivationReq,
    GiftCardBalanceReq,
    PhysicalGiftCardReq,
    PhysicalGiftCardUpdReq,
    VirtualGiftCardUpdReq,
} from '../models/gift-cards-request.model';

import { ApiGiftCard } from '@api/_api/api-gift-card/models/api-gift-card.models';
import { GiftCard, VirtualGiftCardReq } from '@api/gift-card/models/gift-card.models';
import { GiftCardForm } from '@pages/gift-card/store/gift-card.states';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace GiftCardActions {
    /* ------------- Acciones getCard ------------- */

    export const GetPhysicalGiftCard = createAction('[Gift Card] Get physical Gift Card data');
    export const GetVirtualGiftCard = createAction('[Gift Card] Get virtual Gift Card data');
    export const GetBothGiftCards = createAction('[Gift Card] Get physical and virtual data');
    export const GetBothGiftCardsSuccess = createAction('[Gift Card] Get physical and virtual data success', props<{ data }>());
    export const GetGiftCardSuccess = createAction('[Gift Card] Get physical or virtual data success', props<{ payload: GiftCard }>());
    export const GetGiftCardFailure = createAction('[Gift Card] Get physical or virtual data fail', props<Error>());

    /* ------------- Acciones getCardData ------------ */

    export const GetVirtualGiftCardData = createAction('[Gift Card] Create virtual Gift Card ', props<{ orderItemId: string }>());
    export const GetVirtualGiftCardDataSuccess = createAction('[Gift Card] Create virtual Gift Card success', props<{ virtualGiftCardData: VirtualGiftCardReq }>());
    export const GetPhysicalGiftCardData = createAction('[Gift Card] Create physical Gift Card', props<{ orderItemId: string }>());
    export const GetGiftCardDataSuccess = createAction('[Gift Card] Create Gift Card success', props<{ giftCard: GiftCard }>());

    /* ------------- Acciones addToShopCart ------------ */

    export const AddToShopCartPhysicalGiftCard = createAction(
        '[Gift Card] Add Physical Gift Card to shopcart',
        props<{ payload: PhysicalGiftCardReq }>(),
    );
    export const AddToShopCartVirtualGiftCard = createAction(
        '[Gift Card] Add Virtual Gift Card to shopcart',
        props<{ payload: VirtualGiftCardReq }>(),
    );
    export const AddToShopCartSuccess = createAction(
        '[Gift Card] Add Virtual Gift Card to shopcart success',
        props<{ giftCardData: Partial<ApiGiftCard> }>(),
    );

    /* export const updateShopCart = createAction(
      '[Gift Card Cart] Update cart',
    ); */

    export const AddToShopCartFailure = createAction('[Gift Card] Add Virtual Gift Card to shopcart Failure', props<{ error: any }>());

    /* ------------- Acciones activate giftcard ------------ */

    export const ActivateGiftCard = createAction('[Gift Card] Activate Gift Card', props<{ payload: GiftCardActivationReq }>());

    export const ActivateGiftCardSuccess = createAction('[Gift Card] Activate Gift Card Success', props<{ payload: GiftCard }>());

    export const ActivateGiftCardFailure = createAction('[Gift Card] Activate giftcard fail', props<{ error: any }>());

    /* ------------- Acciones getBalance ------------ */

    export const ShowGiftCardSearch = createAction('[Gift Card] Get Gift Card search');

    export const ShowGiftCardBalance = createAction('[Gift Card] Get Gift Card balance', props<{ payload: GiftCardBalanceReq }>());

    export const GetGiftCardBalanceSuccess = createAction('[Gift Card] Get Gift Card balance Success', props<{ total: string; transactions: GiftCardTransaction[] }>());

    export const GetGiftCardBalanceFailure = createAction('[Gift Card] Get Gift Card balance fail', props<{ error: any }>());

    /* ------------- Acciones update giftcard ------------ */

    export const UpdatePhysicalGiftCard = createAction(
        '[Gift Card] Updates Physical Gift Card',
        props<{ orderItemId: string; physicalGiftCardUpdateData: PhysicalGiftCardUpdReq }>(),
    );
    export const UpdateVirtualGiftCard = createAction(
        '[Gift Card] Updates Virtual Gift Card',
        props<{ orderItemId: string; virtualGiftCardUpdateData: VirtualGiftCardUpdReq }>(),
    );
    export const UpdateVirtualGiftCardSuccess = createAction('[Gift Card] Updates Gift Card Success', props<{ payload: GiftCard }>());

    /* -----------  Acciones de Error ------------- */

    export const ErrorGiftCardAction = createAction('[Gift Card] Error', props<Error>());

    export const SetSkuGiftCard = createAction('[Gift Card] SET SKU GIFT CARD', props<{ sku: number }>());

    export const SetGiftCardSaved = createAction('[Gift Card] SET GIFT CARD SAVED', props<{ saved: boolean }>());

    export const SetGiftCardForm = createAction('[Gift Card] SET FORM GIFT CARD', props<{ form: GiftCardForm }>());

    export const SetGiftCardType = createAction('[Gift Card] SET GIFT CARD TYPE', props<{ giftCardType: string }>());

    export const SetGiftCardCustomize = createAction('[Gift Card] SET GIFT CARD CUSTOMIZE', props<{ customizeSelected: any }>());

    export const ResetGiftCardForm = createAction('[Gift Card] RESET FORM GIFT CARD');
    export const RemoveGiftCard = createAction('[Gift Card] REMOVE GIFT CARD');
}
